export default "__VITE_ASSET__CCX2HFF7__"